"use strict";

const ProjectFactSheetController = require("../construction/projectFactSheetController");

const LidProjectFactSheetController = function () {
  const routeName = "lid-fact-sheet";

  var getConfig = function () {
    const LidIcon = require("./lidIcon");
    const SortUtilities = require("../general/sortUtilities");
    const alphaSorter = SortUtilities.alphaSorter;
    const numberSorter = SortUtilities.numberSorter;

    return {
      ...ProjectFactSheetController.getConfig(),
      template: "factSheet/construction/lidProjectFactSheet.njk",
      dataSorting: {
        history: { key: "date", reversed: true },
        linkedAssets: { key: "type" },
      },
      iconFunction: LidIcon.getLidProjectMapIcon,
      closeUrl: "/ram/lid/lid-project",
      goToMapFunction: () => Analytics.sendDataListEvent("address_to_map", "lid-project"),
      getDataFunction: getData,
      onCloseFunction: onClose,
      afterOpenFunction: afterOpen,
      tableTemplates: {
        history: "factSheet/construction/lidHistoryRows.njk",
        linkedAssets: "factSheet/construction/lidAssetRows.njk",
      },
      sortersDict: {
        displayType: alphaSorter,
        assetId: alphaSorter,
        type: alphaSorter,
        date: alphaSorter,
        lastResultDate: alphaSorter,
        installDate: alphaSorter,
        result: alphaSorter,
        lastResult: alphaSorter,
        treatmentCapacity: numberSorter,
        drainageArea: numberSorter,
        imperviousAreaAcres: numberSorter,
      },
    };
  };

  var getData = async function (id) {
    try {
      return await ApiCalls.getLidProjectForFactSheet(id);
    } catch (e) {
      ApiError.assertIs(e);
      if (e.status === 404) {
        return e;
      }
    }

    return await ResourceController.get("postConstructionProjectG2").getById(id);
  };

  var open = function (id, options = {}) {
    return FactSheetNew.open(id, getConfig(), null, options);
  };

  var afterOpen = function () {
    _loadListeners();
    _handleMessages();
  };

  const _handleMessages = function () {
    const channel = `lid-project.${FactSheetNew.getId()}`;

    Messages.subscribe({
      channel,
      event: "update",
      callback: (data) => FactSheetNew.reload(data.project),
    });
  };

  var _unloadListeners = function () {
    ProjectFactSheetController.unloadListeners();
  };

  var _loadListeners = function () {
    _unloadListeners();
    ProjectFactSheetController.loadListeners();
  };

  var onClose = function () {
    _unloadListeners();
    const channel = `lid-project.${FactSheetNew.getId()}`;
    Messages.unsubscribe(channel);
  };

  return {
    open,
    routeName,
  };
};

module.exports = LidProjectFactSheetController();

const ApiCalls = require("../apiCalls");
const ApiError = require("../errors/apiError");
const ResourceController = require("../offline/resourceController");
const FactSheetNew = require("../general/factSheetNew");
const Analytics = require("../general/analytics");
const Messages = require("../messages");
